
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import writeXlsxFile from 'write-excel-file';
import { MediaService } from '@spartacus/storefront';
import { isPlatformBrowser } from '@angular/common';
@Injectable({
    providedIn: 'root',
})
export class KbExportToXlsxService {
    platformId = inject(PLATFORM_ID); 
    mediaService = inject( MediaService)
    EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    EXCEL_EXTENSION = '.xlsx';
    //method for exporting json formatted data
    exportCustomExcel(data: any[], fileName: string) {

        //custom impl
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = {
            Sheets: {
                'sheet 0': worksheet
            },
            SheetNames: ['sheet 0']
        }
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

        const blobData = new Blob([excelBuffer], { type: this.EXCEL_TYPE });
        FileSaver.saveAs(blobData, `${fileName}${this.EXCEL_EXTENSION}`);
    }

    exportwithBoldHeader(inputObject: any, fileName: string) {
        const data: any = this.refactorObject(inputObject);

        writeXlsxFile(data, {
            stickyColumnsCount: 0,
            fileName: fileName
        })

    }
    refactorObject(inputObject) {
        const HEADER_ROW = inputObject.headers.map(header => ({
            value: header.value.trim(),
            fontWeight: header.fontWeight.toLowerCase()
        }));

        const dataRows = [];

        for (let i = 0; i < inputObject.rowsData.length; i++) {
            if (inputObject.rowsData[i] && inputObject.rowsData[i].rows) {
                const dataRow = inputObject.rowsData[i].rows.map((row) => ({
                    type: String,
                    value: row.value.trim()
                }));

                dataRows.push(dataRow);
            }
        }

        const data = [HEADER_ROW, ...dataRows];


        return data;
    }
    exportDataToExcel(media: any, name: string) {
        try {

        const mediaFile = this.mediaService.getMedia(media)
        if (isPlatformBrowser(this.platformId)) {
        window.open(mediaFile?.src)
        }
        } catch (error) {
          console.error('Error downloading Excel file:', error);
        }
      }
}
